import React from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Select from 'react-select';

//To show as drop-down on nav-bar
const Administration = props => {
  const { navigate } = props;
  const { t } = useTranslation();

  const urlInfo = window.location.toString().split('/');
  const linkText = urlInfo.pop();

  //Custom style for drop-down
  const Styles = {
    control: styles => {
      return {
        ...styles,
        backgroundColor: 'transparent',
        border: 'none',
        // This line disables the blue border
        boxShadow: 'none',
        cursor: 'pointer',
      };
    },
    menu: defaultStyles => {
      return {
        ...defaultStyles,
        width: '300px',
      };
    },
    dropdownIndicator: defaultStyles => {
      return {
        ...defaultStyles,
        position: 'relative',
        right: '8px',
        padding: 0,
      };
    },
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color:
          linkText === 'UM' || linkText === 'DM'
            ? 'white'
            : 'rgba(255,255,255,.55)',
      };
    },
  };

  //options for drop-down
  const adminOptions = [
    {
      label: t('User_Management'),
      value: 'User_Management',
    },
    {
      label: t('Department_Management'),
      value: 'Department_Management',
    },
  ];

  //To handle the onchange of drop-down
  const handleChange = event => {
    if (event.value === 'User_Management') {
      navigate('/UM');
    } else if (event.value === 'Department_Management') {
      navigate('/DM');
    }
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowDropDownIcon
          style={{
            color:
              linkText === 'UM' || linkText === 'DM'
                ? 'white'
                : 'rgba(255,255,255,.55)',
            fontSize: 40,
          }}
        />
      </components.DropdownIndicator>
    );
  };

  return (
    <Select
      onChange={handleChange}
      options={adminOptions}
      styles={Styles}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator,
      }}
      value={t('Administration')}
      placeholder={t('Administration')}
      isSearchable={false}
    />
  );
};

export default Administration;
